import { render, staticRenderFns } from "./PleurisyUpdateModal.vue?vue&type=template&id=84c5711c&scoped=true&"
import script from "./PleurisyUpdateModal.vue?vue&type=script&lang=ts&"
export * from "./PleurisyUpdateModal.vue?vue&type=script&lang=ts&"
import style0 from "./PleurisyUpdateModal.vue?vue&type=style&index=0&id=84c5711c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c5711c",
  null
  
)

export default component.exports